<template>
  <el-dialog
    :visible.sync="drawerDialog"
    title="详情"
    width="600px"
    append-to-body
  >
    <el-form
      label-position="left"
      :rules="rules"
      :model="infoData"
      ref="formRef"
      label-width="80px"
    >
      <el-form-item label="PIN">
        {{ infoData.pin }}
      </el-form-item>
      <el-form-item label="账号名">
        <span>{{ infoData.loginName }}</span>
      </el-form-item>
      <el-form-item label="客户名称">
        <p>{{ infoData.name || '--' }}</p>
      </el-form-item>
      <el-form-item label="关联时间">
        <p>{{ infoData.relTime }}</p>
      </el-form-item>
      <el-form-item label="联系电话" prop="tel">
        <el-input v-model="infoData.tel" placeholder="请输入联系电话" />
      </el-form-item>
      <el-form-item label="邮箱" prop="email">
        <el-input v-model="infoData.email" placeholder="请输入邮箱" />
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input
          v-model="infoData.remark"
          type="textarea"
          placeholder="请输入备注"
        />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="drawerDialog = false">取 消</el-button>
      <el-button
        type="primary"
        @click="updateFirstClientInfo"
        :loading="loading"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { modifyFirstClientInfo } from '@/api/distributor-api'
import { OWNER_COMPANY_INFO_RULE } from '@/views/service/rules'
export default {
  props: ['instance'],
  data() {
    return {
      infoData: {
        tel: '',
        email: '',
        remark: '',
      },
      rules: OWNER_COMPANY_INFO_RULE.call(this),
      drawerDialog: false,
      loading: false,
    }
  },
  watch: {
    drawerDialog(val) {
      if (val) {
        this.infoData = {
          ...this.instance,
        }
      }
    },
  },
  methods: {
    open() {
      this.drawerDialog = true
    },
    // 提交表单
    async updateFirstClientInfo() {
      try {
        await this.$refs.formRef.validate()
        this.loading = true
        await modifyFirstClientInfo(
          {
            ...this.infoData,
            pin: this.infoData.pin,
          },
          false,
        )
        this.$message({
          message: '修改成功',
          type: 'success',
        })
        this.drawerDialog = false
        this.$emit('success')
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
